import { IProductDataV2, IProductDataV3, Product } from '@df/catalog/product/product';
import { CacheService } from '@df/core/cache/cache';
import { Giftcards } from '@df/module-giftcards/giftcards';
import { NgInject } from '@df/ng/ng-inject';
import find from 'lodash-es/find';

export class GiftcardsProductPlugin {
    @NgInject(CacheService)
    private cacheService!: CacheService;

    constructor(private product: Product) {}

    /**
     * Checks if product is giftcard
     * @returns {boolean | undefined}
     */
    get isGiftcard(): boolean | undefined {
        return this.cacheService.get(['isGiftcard', this.product.id, this.product.verbosity], () => {
            if (this.product.hasV2) {
                const data = this.product.data as IProductDataV2;
                return (
                    data?.type_id === Giftcards.giftcardTypeId || !!find(this.product.existingChildren, child => child.giftCard?.isGiftcard)
                );
            }
            return undefined;
        });
    }

    /**
     * Is virtual giftcard
     * @returns {boolean | undefined}
     */
    isVirtual(): boolean | undefined {
        const id = this.typeId();
        return id ? id === Giftcards.Type.Virtual : undefined;
    }

    /**
     * Is physical giftcard
     * @returns {boolean | undefined}
     */
    isPhysical(): boolean | undefined {
        const id = this.typeId();
        return id ? id === Giftcards.Type.Printed : undefined;
    }

    /**
     * Is combined giftcard
     * @returns {boolean | undefined}
     */
    isCombined(): boolean | undefined {
        const id = this.typeId();
        return id ? id === Giftcards.Type.Combined : undefined;
    }

    /**
     * Returns giftcard type id
     * @returns {number | undefined}
     */
    private typeId(): number | undefined {
        if (this.product.hasV3 && this.isGiftcard) {
            const product = this.product as Product<IProductDataV3>;
            if (product.isConfigurable) {
                const childrenTypes = product.existingChildren
                    .map(child => (child.data as IProductDataV3).am_giftcard_type)
                    .filter(i => !!i);
                return childrenTypes[0];
            } else {
                return (product.data as IProductDataV3).am_giftcard_type;
            }
        }
        return undefined;
    }
}
